import i18next from 'i18next';
import syncAuthLanguage from '../auth/syncAuthLanguage';

export default async function switchLang(lang: string) {
  await i18next.changeLanguage(lang);
  document.documentElement.lang = i18next.language;
  syncAuthLanguage(undefined, lang);
}
